import React, { useEffect, useState } from 'react'
import BySearchField from './BySearchField'
import ByFilters from './ByFilters';
import { isMobile } from 'react-device-detect';

const SearchForm = (props) => { 
  return(
        <div className="formfields formfields-recipefinder">
            <BySearchField {...props} />
            {!isMobile && <div className="filter-group">
              <ByFilters {...props} />
            </div>}
            {isMobile && <ByFilters {...props} />}
        </div>
  )  
};

export default SearchForm;
